import React, { useState, useEffect } from 'react';
import {
  Modal,
  Radio,
  Card,
  Input,
  Divider,
  Typography,
  List,
  Button,
  Menu,
  Form,
  Avatar,
  Select,
  message,
  Upload,
  Space, Spin
} from "antd";
import './index.css';
import {
    UploadOutlined,
    LoadingOutlined,
    PlusOutlined,
    ExclamationCircleOutlined,
    ClearOutlined,
} from '@ant-design/icons';
import {
    uploadImgRequest,
    getBotRequest,
    getKcsList,
    updateBotKnowledgeRequest
} from './api';
import CreateZhishikuDialog from "../createZhishikuDialog";
import ImagePage from "../imgPage";
import TextPage from "../textPage";
import { API_URL } from '../../../../util/constants';
import Cookies from 'js-cookie';
import { getSixMathRandom } from '../../../../util/handMath';
// const API_URL = 'http://ygbhpy.gamepku.com';
const { TextArea } = Input;
const { Title, Paragraph } = Typography;
const { Meta } = Card;
const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
};

// const myZhishikuList = [{dataset_id: "7507235863258021928"},{dataset_id: "7507235863258021928"}]

// const SelectKCSModal = ({ visible, onCancel, setValue, agentName }) => {
const SelectKCSModal = (props) => {

    const [iconImg, setIconImg] = useState('');
    const [loading, setLoading] = useState(false);
    const [current, setCurrent] = useState('1');
    const [form] = Form.useForm();
    const [nameCount, setNameCount] = useState(0);
    const [descCount, setDescCount] = useState(0);
    const [items, setItems] = useState([
        {
            key: '1',
            label: (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                    }}
                >
                    <span style={{ lineHeight: '20px', fontWeight: 600, marginTop: '12px' }}>
                        通用结构
                    </span>
                    <span>适用于多种场景的提示词结构，可以根据具体...</span>
                </div>
            ),
            path: '/',
            content:
                '# 角色: （角色名称）\n角色概述和主要职责的一句话描述\n\n##目标:\n角色的工作目标，如果有多目标可以分点列出，但建议更聚焦1-2个目标\n## 技能:\n\n1.为了实现目标，角色需要具备的技能1\n2.为了实现目标，角色需要具备的技能2\n3.为了实现目标，角色需要具备的技能3\n## 工作流:\n\n1.描述角色工作流程的第一步\n2.描述角色工作流程的第二步\n3.描述角色工作流程的第三步\n## 输出格式:\n\n如果对角色的输出格式有特定要求，可以在这里强调并举例说明想要的输出格式\n##限制:\n\n描述角色在互动过程中需要遵循的限制条件1\n描述角色在互动过程中需要遵循的限制条件2\n描述角色在互动过程中需要遵循的限制条件3',
        },
        {
            key: '2',
            label: (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                    }}
                >
                    <span style={{ lineHeight: '20px', fontWeight: 600, marginTop: '12px' }}>
                        任务执行
                    </span>
                    <span>适用于有明确的工作步骤的任务执行场景，通...</span>
                </div>
            ),
            path: '/react-app-1',
            content:
                '# 角色\n你是××（角色设定，比如xx领域的专家）\n你的目标是希望模型执行什么任务，达成什么目标\n#以下可以采用先总括，再展开详细说明的方式，描述你希望智能体在每一个步骤如何进行工作，具体的工作步骤数量可以根据实际需求增删#\n\n## 工作步骤\n\nI.工作流程1的一句话概括\n2.工作流程2的一句话概括\n3.工作流程3的一句话概括\n\n### 第一步 工作流程1标题\n工作流程步骤1的具体工作要求和举例说明，可以分点列出希望在本步骤做哪些事情，需要完成什么阶段性的工作目标\n\n### 第二步 工作流程2标题\n工作流程步骤2的具体工作要求和举例说明，可以分点列出希望在本步骤做哪些事情，需要完成什么阶段性的工作目标\n\n### 第三步 工作流程3标题\n工作流程步骤3的具体工作要求和举例说明，可以分点列出希望在本步骤做哪些事情，需要完成什么阶段性的工作目标\n\n通过这样的对话，你可以 智能体工作目标再次强调',
        },

        {
            key: '3',
            label: (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                    }}
                >
                    <span style={{ lineHeight: '20px', fontWeight: 600, marginTop: '12px' }}>
                        角色扮演
                    </span>
                    <span>适用于聊天陪伴、互动娱乐场景、可帮助模型...</span>
                </div>
            ),
            path: '/react-app-2',
            content:
                '你将扮演一个人物角色 角色名称 ，以下是关于这个角色的详细设定，请根据这些信息来构建你的回答。\n\n**人物基本信息:**\n\n你是: 角色的名称、身份等基本介绍\n人称:第一人称\n出身背景与上下文:交代角色背景信息和上下文\n\n**性格特点:**\n\n性格特点描述\n\n**语言风格:**\n\n语言风格描述\n\n**人际关系:**\n\n人际关系描述\n\n**过往经历:**\n\n过往经历描述\n\n**经典台词或口头禅:**\n\n补充信息: 即你可以将动作、神情语气、心理活动、故事背景放在（）中来表示，为对话提供补充信息。\n\n台词1: 角色台词示例1\n台词2:角色台词示例2\n\n要求:\n根据上述提供的角色设定，以第一人称视角进行表达。\n在回答时，尽可能地融入该角色的性格特点、语言风格以及其特有的口头禅或经典台词。\n如果适用的话，在适当的地方加入（）内的补充信息，如动作、神情等，以增强对话的真实感和生动性。',
        },

    ]);
    const [dataList, setDataList] = useState([]);
    const [myZhishikuList, setMyZhishikuList] = useState([]);
   const [isLoading, setIsLoading] = useState(false);
  const [isShowCreateZhishikuDialog, setIsShowCreateZhishikuDialog] = useState(false);
  const [isShowTextPage, setIsShowTextPage] = useState(false);
  //控制图片类型的知识库上传
  const [isShowImagePage, setIsShowImagePage] = useState(false);
  const [dataset_id, setDataset_id] = useState('');

  const updateSelectZhishikuList = (index,type) => {

    setIsLoading(true);

    var listNew = [];
    if(type==='add'){
      var bean = {id:dataList[index].dataset_id, name:dataList[index].name}
      console.log(bean)

      var list = myZhishikuList;
      list.push(bean)
      console.log(list)
      setMyZhishikuList(list)

      listNew = myZhishikuList.map(item => item.id);
      console.log(listNew)

    }else if(type==='del'){
      var id_del = dataList[index].dataset_id;
      var list2 = myZhishikuList;
      list2 = list2.filter(item => item.id !== id_del);
      console.log(list2)
      setMyZhishikuList(list2)
      const listNew2 = myZhishikuList.map(item => item.id);
      console.log(listNew2)
      listNew =  listNew2.filter(item => item !== id_del);
      console.log(listNew)
      console.log(myZhishikuList)

    }

    updateBotKnowledgeRequest({
        "bot_id": props.bot_id,
        "knowledge": {
          "dataset_ids": listNew,
          "auto_call": true,
          "search_strategy": 0
        }
          },
          (res) => {
            if (res.ret == 1) {
              message.success("智能体更新成功！");
              getBotInfo();
              //getKcsListFn('')
              setIsLoading(false);
            }else{
              setIsLoading(false);
              message.error("智能体更新失败！");
            }
          }
        );

  };

  const getBotInfo = () => {

    getBotRequest(props.bot_id, (data) => {
      console.log(data);
      if (data.ret == 1) {
        let objData = data.botInfo;
        if(objData.knowledge.knowledge_infos){
          setMyZhishikuList(objData.knowledge.knowledge_infos);

          var zhishikuList = objData.knowledge.knowledge_infos;
          const updatedList = dataList.map(item => {
            // 检查 myZhishikuList 中是否存在相同的 dataset_id
            const exists = zhishikuList.some(z => z.id === item.dataset_id);

            // 存在则 status_add: 1，不存在则 status_add: 0
            return {
              ...item,
              status_add: exists ? 1 : 0
            };
          });
          setDataList(updatedList);
        }else{
        }

        props.onSuccess(data)

      }
    });
  }

    const handleCancel = () => {
      const newArray = dataList.map(item => ({
        ...item,
        status_add: 0
      }));
      setDataList(newArray)

      props.onCancel()

    }

  const handleOk = () => {
    const filteredList = dataList.filter(item => item.status_add == 1);
    props.onOk(filteredList)
    props.onCancel()
  }

  const getKcsListFn = (format_type) => {
    getKcsList(
      {
        space_id: Cookies.get('coze_space_id'),
        // name: agentName,
        name: '',
        format_type: format_type,
        page_num: 1,
        page_size: 300,//这里接口有问题，page_size不起作用
      },
      (res) => {
        if (res.ret == 1) {
          let result = res.data;
          console.log(result);
          if(props.bot_id==undefined){
              return
          }
          //add
          getBotRequest(props.bot_id, (data) => {
            console.log(data);
            if (data.ret == 1) {
              let objData = data.botInfo;

              props.onSuccess(data);

              if(objData.knowledge.knowledge_infos){
                setMyZhishikuList(objData.knowledge.knowledge_infos);
                var zhishikuList = objData.knowledge.knowledge_infos;

                const updatedList = result.map(item => {
                  // 检查 myZhishikuList 中是否存在相同的 dataset_id
                  const exists = zhishikuList.some(z => z.id === item.dataset_id);
                  // 存在则 status_add: 1，不存在则 status_add: 0
                  return {
                    ...item,
                    status_add: exists ? 1 : 0
                  };
                });
                setDataList(updatedList);
              }else{
                setMyZhishikuList([]);
                setDataList(result);
              }

            }
          });

        }
      }
    );

  };

  function onSuccessCreateZhishiku(format_type,importType,dataset_id) {
    setIsShowCreateZhishikuDialog(false);
    //message.success("知识库创建成功", 2);

    getKcsListFn('');

    setDataset_id(dataset_id)

    if(format_type=='0'){//文本类型
      setIsShowTextPage(true)
    } else if(format_type=='2'){//图片类型
      setIsShowImagePage(true)
    }

  }

  function onSuccessImport(){
    getKcsListFn('')
  }


  useEffect(() => {

    getKcsListFn('')

    }, []);
    const onClick = (e) => {
        console.log('click ', e, items);
        setCurrent(e.key);
        items.forEach((it) => {
            if (e.key == it.key) {
                setTishiValue(it.content);
            }
        });
    };
    const [activeTab, setActiveTab] = useState('template');
    const [disableCreate, setDisableCreate] = useState(true);
    const clickTitle = (e) => {
        if (e.target.tagName === 'SPAN') {
            const selected = e.target.textContent === '模版' ? 'template' : 'custom';
            setActiveTab(selected);
            if (e.target.textContent === '自定义') {
                setDisableCreate(false);
                setCurrent('1');
                setItems([
                    {
                        key: '1',
                        label: (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <span
                                    style={{
                                        lineHeight: '20px',
                                        fontWeight: 600,
                                        marginTop: '12px',
                                    }}
                                >
                                    通用结构
                                </span>
                                <span>适用于多种场景的提示词结构，可以根据具体...</span>
                            </div>
                        ),
                        path: '/',
                        content:
                            '# 角色: （角色名称）\n角色概述和主要职责的一句话描述\n## 目标:\n- 角色的工作目标1\n- 角色的工作目标2\n## 技能:\n1. 技能1\n2. 技能2\n3. 技能3\n## 工作流:\n1. 工作流程第一步\n2. 工作流程第二步\n3. 工作流程第三步\n## 输出格式:\n- 指定格式要求（示例：使用Markdown表格/JSON格式）\n## 限制:\n- 必须遵循的条件或约束1\n- 必须遵循的条件或约束2\n- 必须遵循的条件或约束3',
                    },
                ]);
                setTishiValue('');
            } else {
                setCurrent('1');
                setDisableCreate(true);
                setItems([
                    {
                        key: '1',
                        label: (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <span
                                    style={{
                                        lineHeight: '20px',
                                        fontWeight: 600,
                                        marginTop: '12px',
                                    }}
                                >
                                    通用结构
                                </span>
                                <span>适用于多种场景的提示词结构，可以根据具体...</span>
                            </div>
                        ),
                        path: '/',
                        content:
                            '# 角色: （角色名称）\n角色概述和主要职责的一句话描述\n\n##目标:\n角色的工作目标，如果有多目标可以分点列出，但建议更聚焦1-2个目标\n## 技能:\n\n1.为了实现目标，角色需要具备的技能1\n2.为了实现目标，角色需要具备的技能2\n3.为了实现目标，角色需要具备的技能3\n## 工作流:\n\n1.描述角色工作流程的第一步\n2.描述角色工作流程的第二步\n3.描述角色工作流程的第三步\n## 输出格式:\n\n如果对角色的输出格式有特定要求，可以在这里强调并举例说明想要的输出格式\n##限制:\n\n描述角色在互动过程中需要遵循的限制条件1\n描述角色在互动过程中需要遵循的限制条件2\n描述角色在互动过程中需要遵循的限制条件3',
                    },
                    {
                        key: '2',
                        label: (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <span
                                    style={{
                                        lineHeight: '20px',
                                        fontWeight: 600,
                                        marginTop: '12px',
                                    }}
                                >
                                    任务执行
                                </span>
                                <span>适用于有明确的工作步骤的任务执行场景，通...</span>
                            </div>
                        ),
                        path: '/react-app-1',
                        content:
                            '# 角色\n你是××（角色设定，比如xx领域的专家）\n你的目标是希望模型执行什么任务，达成什么目标\n#以下可以采用先总括，再展开详细说明的方式，描述你希望智能体在每一个步骤如何进行工作，具体的工作步骤数量可以根据实际需求增删#\n\n## 工作步骤\n\nI.工作流程1的一句话概括\n2.工作流程2的一句话概括\n3.工作流程3的一句话概括\n\n### 第一步 工作流程1标题\n工作流程步骤1的具体工作要求和举例说明，可以分点列出希望在本步骤做哪些事情，需要完成什么阶段性的工作目标\n\n### 第二步 工作流程2标题\n工作流程步骤2的具体工作要求和举例说明，可以分点列出希望在本步骤做哪些事情，需要完成什么阶段性的工作目标\n\n### 第三步 工作流程3标题\n工作流程步骤3的具体工作要求和举例说明，可以分点列出希望在本步骤做哪些事情，需要完成什么阶段性的工作目标\n\n通过这样的对话，你可以 智能体工作目标再次强调',
                    },

                    {
                        key: '3',
                        label: (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <span
                                    style={{
                                        lineHeight: '20px',
                                        fontWeight: 600,
                                        marginTop: '12px',
                                    }}
            s                    >
                                    角色扮演
                                </span>
                                <span>适用于聊天陪伴、互动娱乐场景、可帮助模型...</span>
                            </div>
                        ),
                        path: '/react-app-2',
                        content:
                            '你将扮演一个人物角色 角色名称 ，以下是关于这个角色的详细设定，请根据这些信息来构建你的回答。\n\n**人物基本信息:**\n\n你是: 角色的名称、身份等基本介绍\n人称:第一人称\n出身背景与上下文:交代角色背景信息和上下文\n\n**性格特点:**\n\n性格特点描述\n\n**语言风格:**\n\n语言风格描述\n\n**人际关系:**\n\n人际关系描述\n\n**过往经历:**\n\n过往经历描述\n\n**经典台词或口头禅:**\n\n补充信息: 即你可以将动作、神情语气、心理活动、故事背景放在（）中来表示，为对话提供补充信息。\n\n台词1: 角色台词示例1\n台词2:角色台词示例2\n\n要求:\n根据上述提供的角色设定，以第一人称视角进行表达。\n在回答时，尽可能地融入该角色的性格特点、语言风格以及其特有的口头禅或经典台词。\n如果适用的话，在适当的地方加入（）内的补充信息，如动作、神情等，以增强对话的真实感和生动性。',
                    },
                ]);
                setTishiValue(
                    '# 角色: （角色名称）\n角色概述和主要职责的一句话描述\n\n##目标:\n角色的工作目标，如果有多目标可以分点列出，但建议更聚焦1-2个目标\n## 技能:\n\n1.为了实现目标，角色需要具备的技能1\n2.为了实现目标，角色需要具备的技能2\n3.为了实现目标，角色需要具备的技能3\n## 工作流:\n\n1.描述角色工作流程的第一步\n2.描述角色工作流程的第二步\n3.描述角色工作流程的第三步\n## 输出格式:\n\n如果对角色的输出格式有特定要求，可以在这里强调并举例说明想要的输出格式\n##限制:\n\n描述角色在互动过程中需要遵循的限制条件1\n描述角色在互动过程中需要遵循的限制条件2\n描述角色在互动过程中需要遵循的限制条件3'
                );
            }
        }
    };
    const [visibleCreate, setVisibleCreate] = useState(false);
    const onCancelCreate = () => {
        setVisibleCreate(false);
    };
    const createFn = () => {
        // setVisibleCreate(true);
      setIsShowCreateZhishikuDialog(true)
    };
    const [tishiValue, setTishiValue] = useState(
        '# 角色: （角色名称）\n角色概述和主要职责的一句话描述\n\n##目标:\n角色的工作目标，如果有多目标可以分点列出，但建议更聚焦1-2个目标\n## 技能:\n\n1.为了实现目标，角色需要具备的技能1\n2.为了实现目标，角色需要具备的技能2\n3.为了实现目标，角色需要具备的技能3\n## 工作流:\n\n1.描述角色工作流程的第一步\n2.描述角色工作流程的第二步\n3.描述角色工作流程的第三步\n## 输出格式:\n\n如果对角色的输出格式有特定要求，可以在这里强调并举例说明想要的输出格式\n##限制:\n\n描述角色在互动过程中需要遵循的限制条件1\n描述角色在互动过程中需要遵循的限制条件2\n描述角色在互动过程中需要遵循的限制条件3'
    );
    const changeTishiFn = (e) => {
        console.log(e.target.value, 'e');
        setTishiValue(e.target.value);
    };
    const clickAddTishi = () => {
        props.setValue(tishiValue, false);
    };

    const [fileList, setFileList] = useState([]);
    const beforeUpload = (file) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('You can only upload JPG/PNG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('Image must smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
    };
    const handleChange = (info) => {
        if (info.fileList.length == 2) {
            setFileList([info.fileList[1]]);
        } else {
            setFileList(info.fileList);
        }
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            getBase64(info.file.originFileObj, (url) => {
                setLoading(false);
                setImageUrl(url);
            });
        }
    };
    const customRequest = async ({ file, onSuccess, onError }) => {
        try {
            // 生成新文件名（可根据需求修改）
            const fileExt = file.name.substr(file.name.lastIndexOf('.') + 1);
            const newFileName = `img_${Date.now()}_${Cookies.get('user_login')}.${fileExt}`;

            // 调用你的上传接口
            await uploadImgRequest(file, newFileName, (data) => {
                if (data.ret == 1) {
                    // const fileUrl = `${API_URL}/icons/${newFileName}`;
                    // onSuccess({ ...file, url: fileUrl }, file);
                    // onUploadSuccess?.(fileUrl); // 可选：通知父组件上传成功
                    file.url = API_URL + '/icons/' + newFileName;
                    // file.name = newFileName
                    onSuccess(file);
                    setIconImg(data.imgInfo.id);
                } else {
                    onError(data);
                    message.error('上传失败: ' + (data.message || '未知错误'));
                }
            });
        } catch (error) {
            onError(error);
            message.error('上传失败: ' + error.message);
        }
    };
    const [imageUrl, setImageUrl] = useState();
    const uploadButton = (
        <button
            style={{
                border: 0,
                background: 'none',
            }}
            type='button'
        >
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </button>
    );
    return (
        <div>
            <Modal
                maskClosable={false}
                title='选择知识库'
                visible={props.visible}
                onCancel={handleCancel}
                onOk={handleOk}
                width={800}
                // footer={null}
                bodyStyle={{ padding: 0 }}
                okText='确定'
                cancelText='取消'
            >
                <div className='dialog_content_box'>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            margin: '15px 0px',
                        }}
                    >
                        <Select
                          defaultValue='全部'
                            style={{
                                width: 120,
                            }}
                            options={[
                                {
                                    value: '',
                                    label: '全部',
                                },
                                {
                                    value: '0',
                                    label: '文本',
                                },
                                {
                                    value: '2',
                                    label: '图片',
                                },
                            ]}
                            onChange={(value) => {
                              getKcsListFn(value);
                            }}
                        />
                        <Button type='primary' onClick={() => createFn()}>
                            创建知识库
                        </Button>
                    </div>
                    <List
                        className='scrollable-list'
                        itemLayout='horizontal'
                        dataSource={dataList}
                        renderItem={(item, index) => (
                            <List.Item>
                                <List.Item.Meta
                                    avatar={<Avatar src={item.icon_url} />}
                                    // title={<a href='https://ant.design'>{item.name}</a>}
                                    title={<a >{item.name}</a>}
                                    description={
                                        <div>
                                            <div>{item.description}</div>
                                            <div>2025-10-12</div>
                                        </div>
                                    }
                                />
                                <div style={{marginRight:20}}>
                                    {item.status_add==1 ? (
                                        <Button style={{ color: '#1677ff' }}
                                                onClick={() => {
                                                  updateSelectZhishikuList(index,'del')
                                                }}>已添加</Button>
                                    ) : (
                                        <Button onClick={() => {
                                          updateSelectZhishikuList(index,'add')
                                        }}>添加</Button>
                                    )}
                                </div>
                            </List.Item>
                        )}
                    />
                </div>


              {isLoading?
                <Spin
                  size="large"
                  style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 10000000000
                  }}/>:null}
            </Modal>

          {isShowCreateZhishikuDialog ?
            <CreateZhishikuDialog
              space_id={Cookies.get('coze_space_id')} bot_id={props.bot_id}
              onCancelCreate={() => setIsShowCreateZhishikuDialog(false)} // 改为箭头函数
              onSuccess={onSuccessCreateZhishiku} // 改为箭头函数
              onSuccessImport={onSuccessImport}

            /> : null}

          {isShowImagePage ? (
            <ImagePage
              id={dataset_id}
              // onChange={onChangeClose}
              onCancelImgPage={() => setIsShowImagePage(false)}/>//id为知识库的id
          ) : null}

          {isShowTextPage ? (
            <TextPage
              id={dataset_id}
              // onChange={onChangeClose}
              onCancelTextPage={() => setIsShowTextPage(false)} />
          ) : null}


        </div>
    );
};

export default SelectKCSModal;
